export default __webpack_public_path__ + "resources/icons/n242-1f42.png";